import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router'
import { PermissionService } from "./permission.service"
import { getRoles, getTicket } from '@app/modules/shares/utils/functions/common'

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(
    private _router: Router,
    private _permissionService: PermissionService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot) {
    const useRole = getRoles()

    if (!useRole) {
      window.location.assign('/auth/login')
      // return false
    }
    this._permissionService.setRuleUser([
      ...useRole
    ])
    return true
  }
}
